import { Slide } from "vue-burger-menu";

export default {
  name: "Header",
  components: {
    Slide
  },
  data() {
    return {
      newsObj: {},
      newsData: []
    };
  },
  watch: {},
  methods: {},
  created() {}
};
